// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#waiter-detail[data-v-cea74176]{max-width:1280px;margin-left:auto;margin-right:auto}#waiter-detail .box-header .title[data-v-cea74176]{font-size:22px;font-weight:700}#waiter-detail .box-header .spinner[data-v-cea74176]{width:22px;height:22px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
